module.exports = __webpack_public_path__ + "img/carousel-photo05.dae402db.jpg";